import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as innovationAsset from '../innovation-asset'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: innovationAsset.RESOURCE.payload.dimension.partialId,
      partialId: innovationAsset.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'URL associated with the asset documentation, if applicable',
    isOptional: true,
    name: 'Documentation Link',
    partialId: PartialId.Standard.create('documentation_link'),
    type: core.common.value.types.Intrinsic.Url,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
